import { API, graphqlOperation } from 'aws-amplify';
import { listFlexibleFeatures } from 'graphql/queries';
import _ from 'lodash';

const fetchFlexibleFeatures = async (codes) => {
  const filter = {};
  if (codes.includes('A')) {
    filter.simulantA = {
      eq: true
    };
  }
  if (codes.includes('B')) {
    filter.simulantB = {
      eq: true
    };
  }
  if (codes.includes('C')) {
    filter.simulantC = {
      eq: true
    };
  }
  if (codes.includes('D1')) {
    filter.simulantD1 = {
      eq: true
    };
  }
  if (codes.includes('E')) {
    filter.simulantE = {
      eq: true
    };
  }
  if (codes.includes('D2')) {
    filter.simulantD2 = {
      eq: true
    };
  }
  if (codes.includes('alcool95')) {
    filter.alcool95 = {
      eq: true
    };
  }
  let data = [];
  try {
    if (!_.isEmpty(filter)) {
      data = await API.graphql(graphqlOperation(listFlexibleFeatures, {
        filter
      }));
    } else {
      data = await API.graphql(graphqlOperation(listFlexibleFeatures));
    }
  } catch (e) {
    console.error(e);
  }
  return data;
};

export default fetchFlexibleFeatures;
